import {GoogleMapProps} from '@react-google-maps/api'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {midpoint} from './Calcs'
import {DrawInterface} from './DrawInterface'

function getOverlay(position, content) {
  class CustomPopup extends google.maps.OverlayView {
    position: google.maps.LatLng
    containerDiv: HTMLDivElement

    constructor(position: google.maps.LatLng, content: string) {
      super()
      this.position = position

      const contentDiv = document.createElement('div')
      contentDiv.id = 'contentPopup'
      contentDiv.innerHTML = content
      contentDiv.classList.add('popup-bubble')

      // Âncora da bolha
      const bubbleAnchor = document.createElement('div')
      bubbleAnchor.classList.add('popup-bubble-anchor')
      bubbleAnchor.appendChild(contentDiv)

      // Container principal
      this.containerDiv = document.createElement('div')
      this.containerDiv.classList.add('popup-container')
      this.containerDiv.appendChild(bubbleAnchor)

      google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv)
    }

    onAdd() {
      this.getPanes()?.floatPane.appendChild(this.containerDiv)
    }

    onRemove() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }
    }

    draw() {
      const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)
      if (divPosition) {
        const display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none'

        if (display === 'block') {
          this.containerDiv.style.left = `${divPosition.x}px`
          this.containerDiv.style.top = `${divPosition.y}px`
        }

        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display
        }
      }
    }
  }

  return new CustomPopup(position, content)
}

export class Meassure implements DrawInterface {
  active: boolean
  marker: any[]
  path: any[]
  infoWindow: any[]
  map: any
  popup: any
  measureClickCount: number
  constructor(map: GoogleMapProps) {
    this.active = false
    this.marker = []
    this.path = []
    this.infoWindow = []
    this.measureClickCount = 0
    this.map = map
  }
  draw() {
    throw new Error('Method not implemented.')
  }
  setActive(active) {
    const map = this.map

    if (!active) {
      this.clearMarker()
      this.clearPopup()
      const simplesMapTypeComercios = new google.maps.StyledMapType([
        {
          featureType: 'transit.station.bus',
          stylers: [{visibility: 'off'}],
        },
      ])
      map.mapTypes.set('ligth', simplesMapTypeComercios)
      map.setMapTypeId('ligth')
    } else {
      const simplesMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'transit',
            stylers: [{visibility: 'off'}],
          },
          {
            featureType: 'poi',
            stylers: [{visibility: 'off'}],
          },
        ],
        {name: 'Simples'}
      )
      map.mapTypes.set('simples', simplesMapType)
      map.setMapTypeId('simples')
      map.setOptions({draggableCursor: 'crosshair'})
      google.maps.event.clearListeners(map, 'click')
      map.addListener('click', (e) => this.controllClick(e, this.callback))
      this.active = active
    }
  }
  callback() {
    // this.clearPopup()
    // console.log('asdas')
  }
  setMeassureActive() {
    const map = this.map
    this.active = true
    map.setOptions({draggableCursor: 'crosshair'})
  }
  setMeassureDeactive() {
    const map = this.map
    this.active = false
    map.setOptions({draggableCursor: ''})
  }

  controllClick(event: any, callback: any) {
    if (this.active === true) {
      this.setMeassureClickCount()
      this.addMark(this.getMeassureClickCount(), event.latLng.toJSON())
    }
    callback(this.marker, this.active)
  }
  setMarker(m: any) {
    this.marker.push(m)
  }
  setPath(m: any) {
    this.path.push(m)
  }
  setInfoWindow(m: any) {
    this.infoWindow.push(m)
  }
  clearMarker() {
    // eslint-disable-next-line array-callback-return
    this.marker.map((itens) => {
      itens.setMap(null)
    })
    this.marker = []
    // eslint-disable-next-line array-callback-return
    this.path.map((itens) => {
      itens.setMap(null)
    })
    this.path = []
  }

  addPath(path) {
    const map = this.map
    const Path = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
    })
    this.setPath(Path)
    Path.setMap(map)
  }
  clearPopup() {
    Array.from(document.getElementsByClassName('popup-container')).forEach((el) => {
      el.remove()
    })
  }

  drawLines() {
    let result = 0
    const map = this.map

    this.clearPopup()
    // eslint-disable-next-line array-callback-return
    this.marker.map((item, index, itens) => {
      if (index > 0) {
        let p1 = itens[index - 1]
        let p2 = itens[index]
        const pathCoordinates = [
          {lat: p1.getPosition().lat(), lng: p1.getPosition().lng()},
          {lat: p2.getPosition().lat(), lng: p2.getPosition().lng()},
        ]
        result += this.haversine_distance(p1, p2)
        const midpointCoords = midpoint(
          {lat: p1.getPosition().lat(), lng: p1.getPosition().lng()},
          {lat: p2.getPosition().lat(), lng: p2.getPosition().lng()}
        )

        try {
          let popupn = getOverlay(
            new google.maps.LatLng(midpointCoords),
            `<div>Distância: ${(result * 1000).toFixed(0)}m</div>`
          )
          popupn.setMap(map)
        } catch (e) {
          console.log(e)
        }
        this.addPath(pathCoordinates)
      }
    })
  }
  addMark(id, latlng) {
    const map = this.map

    const mark = new google.maps.Marker({
      icon: {
        url: toAbsoluteUrl('/media/dot-measure.png'),
        anchor: new google.maps.Point(3, 3),
      },
      position: latlng,
      map: map,
      title: 'p' + id,
      optimized: true,
      // anchorPoint:new google.maps.Point(0, 32),
    })

    this.setMarker(mark)
    this.drawLines()
  }

  haversine_distance(mk1, mk2) {
    var R = 6371 // Radius of the Earth in miles
    var rlat1 = mk1.getPosition().lat() * (Math.PI / 180) // Convert degrees to radians
    var rlat2 = mk2.getPosition().lat() * (Math.PI / 180) // Convert degrees to radians
    var difflat = rlat2 - rlat1 // Radian difference (latitudes)
    var difflon = (mk2.getPosition().lng() - mk1.getPosition().lng()) * (Math.PI / 180) // Radian difference (longitudes)

    var d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
        )
      )
    return d
  }
  getMarkers() {
    return this.marker
  }
  getMeassureClickCount() {
    return this.measureClickCount
  }
  setMeassureClickCount() {
    this.measureClickCount = this.measureClickCount + 1
  }
  resetMeassureClickCount() {
    this.measureClickCount = -1
  }
  clearMeassureClickCount() {
    this.measureClickCount = -1
  }
}
